<template>
  <div class="card">
    <card-m title="设计BOM进度" cardWidth="100%" cardHeight="90%">
      <template slot="card-box">
        <cardTable
          :total="totalCounts"
          :tableColumn="column"
          :tableData="tableData"
          :loading="loading"
          :showPaging="false"
          @rowClick="goToInfo"
        >
        </cardTable>
      </template>
    </card-m>
    <!-- 设计详情 -->
    <el-dialog
      :visible="detailDialogVisible"
      :before-close="closeDetailDialog"
      width="80%"
    >
      <div class="taskDialog">
        <card-m
          :title="'BOM信息概览：' + FBOMNumber"
          cardWidth="100%"
          cardHeight="100%"
          minHeight="48%"
          maxHeight="100%"
        >
          <template slot="card-box">
            <div class="card-box-table"></div>
            <cardTable
              :total="ERPBOMTotal"
              @sizeChange="handleERPBOMPageSizeChanges"
              @currentChange="handlecurrentERPBOMChanges"
              :tableColumn="ERPBOMListColumn"
              :tableData="ERPBOMList"
            ></cardTable>
          </template>
        </card-m>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//import cardTable from './card-table.vue';
import { apiMain, apiMainMultiple } from '@/api/mainapi.js';
export default {
  //components: { cardTable },
  name: 'card-M',
  props: {
    contractId: String
  },
  data() {
    return {
      FBOMNumber: '',
      detailDialogVisible: false, //设计详情点击弹框
      currentERPBOMPage: 1, //当前页
      ERPBOMTotal: 0, //总数据数
      ERPBOMPageSize: 5, //
      ERPBOMListColumn: [
        {
          prop: 'FName',
          label: '名称'
        },
        {
          prop: 'FModel',
          label: '型号'
        },

        {
          prop: 'stockQty',
          label: '库存'
        },
        {
          prop: 'FQty',
          label: '数量'
        },
        {
          prop: 'wayQty',
          label: '在途数量'
        },
        {
          prop: 'Unit',
          label: '单位'
        },
        {
          prop: 'stock',
          label: '库房'
        },
        {
          prop: 'FShortNumber',
          label: '代码'
        }
      ],
      ERPBOMList: [],
      totalCounts: 0,
      column: [
        {
          prop: 'model',
          label: '父项型号'
        },
        {
          prop: 'name',
          label: '名称'
        },
        {
          prop: 'member',
          label: '设计人'
        },
        {
          prop: 'progress',
          label: '设计进度',
          custom: true,
          column: {
            type: 'progress',
            field: 'progress'
          }
        },
        {
          prop: 'qty',
          label: '数量'
        },
        {
          prop: 'unit',
          label: '单位'
        }
      ],
      tableData: [],
      loading: false
    };
  },
  mounted() {},
  methods: {
    async getTableData(id) {
      const params = {
        Type: 'BOMProgress',
        contractNo: id
      };
      const res = await apiMain(params);
      if (res.data.data.length) {
        this.tableData = res.data.data.slice(0, -1);
        this.tableData.forEach((item) => {
          item.qty = parseInt(item.qty);
        });
      }
    },
    // 跳转产品进度详情
    goToInfo(data) {
      // if (data.FBOMNumber) {
      //   this.$router.push(`/homepage/details?FBOMNumber=${data.FBOMNumber}`);
      // } else {
      //   this.$message.warning('该条数据暂无BOM编号');
      // }
      if (data.FBOMNumber) {
        this.FBOMNumber = data.FBOMNumber;
      } else {
        this.$message.warning('该条数据暂无BOM编号');
      }
      
      this.$nextTick(() => {
        
        this.getERPBOM(data.FBOMNumber);
        
      });
    },
    //从ERP获取BOM数据
    async getERPBOM(FBOMNumber) {
      const params = {
        Type: 'ERPBOM',
        msg: FBOMNumber,
        Page: this.currentERPBOMPage,
        PageSize: this.ERPBOMPageSize
      };
      const res = await apiMainMultiple(params);
      this.ERPBOMTotal = res.data.data.total;
      this.ERPBOMList = res.data.data.list;
      this.detailDialogVisible = true;
    },
    //关闭任务列表详情弹框
    closeDetailDialog() {
      this.detailDialogVisible = false;
    },
    handleERPBOMPageSizeChanges(val) {
      console.log(`每页 ${val} 条`);
      this.ERPBOMPageSize = val;
      this.getERPBOM(this.FBOMNumber);
    },
    handlecurrentERPBOMChanges(val) {
      console.log(`当前页: ${val}`);
      this.currentERPBOMPage = val;
      this.getERPBOM(this.FBOMNumber);
    }
  }
};
</script>

<style scoped scoped lang="scss">
.card {
  width: 100%;
  height: 100%;
}
</style>
